import { APIAccessor, HttpError, ListResponse } from '../utils/api';
import { BaseModel } from './base';

export class NewsModel extends BaseModel {
    public id = '';
    public title = '';
    public content = '';

    // eslint-disable-next-line unicorn/consistent-class-member-order -- conflicts with @typescript-eslint/member-ordering, which requires instance fields before static methods
    public static async getById(id: string, apiAccessor: APIAccessor): Promise<NewsModel | undefined> {
        try {
            const api = await apiAccessor.fetch(`/api/v1/news/${encodeURIComponent(id)}`);
            return this.wrapNew(api);
        } catch (error) {
            if (error instanceof HttpError && (error.status === 404 || error.status === 403)) {
                return undefined;
            }

            throw error;
        }
    }

    public static async getAll(apiAccessor: APIAccessor): Promise<NewsModel[]> {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        const response = (await apiAccessor.fetch(`/api/v1/news`)) as ListResponse;
        return response.items.map((link) => this.wrapNew(link));
    }

    public static wrapNew(object: unknown): NewsModel {
        const news = new NewsModel();
        return news.wrap(object);
    }
}
